"use client";
import Image from "next/image";

export const NoImage = () => {
  return (
    <div className="relative flex h-full w-full overflow-hidden">
      <Image src={"/svg/noImage.svg"} alt="no_image" className="object-cover" fill />
    </div>
  );
};
